module.exports = __webpack_public_path__ + "static/media/SellkeyFunction01.d7247963.png";